module.exports = "/dist/img/noshi01.e703ec6e.jpg";